import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, Result } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import '../Subject/Subject.css';

const ConfirmationModal = ({ isOpen, message, onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={isOpen}
            footer={null}
            onCancel={onClose}
            centered
            closable={false}
            width={400}
        >
            <Result
                icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
                status="success"
                title={t('successfullySaved')}
                subTitle={message}
                extra={[
                    <Button key="ok" type="primary" onClick={onClose}>
                        {t('ok')}
                    </Button>,
                ]}
            />
        </Modal>
    );
};

export default ConfirmationModal;